module.exports = __webpack_public_path__ + "img/diamonds-with@2x.4e70b3d.jpg";